export default function UserAvatar({
  name,
  photoURL,
  size = 40,
}: {
  name?: string;
  photoURL?: string;
  size?: number;
}) {
  const initials =
    name?.split(" ").map(n => n[0]).slice(0,2).join("").toUpperCase() || "M";

  return photoURL ? (
    <img
      src={photoURL}
      alt={name ? `${name}'s profile picture` : ""}
      style={{ width: size, height: size }}
      className="rounded-full object-cover border border-[color:var(--color-border)]"
    />
  ) : (
    <div
      style={{ width: size, height: size }}
      className="grid place-items-center rounded-full border border-[color:var(--color-border)] bg-[color:var(--color-surface)] text-xs font-bold text-[color:var(--color-text-muted)]"
    >
      {initials}
    </div>
  );
}
